import Projects from '@/resources/projects';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'project';

export default {
  namespaced: true,
  actions: {
    async add({ commit }, { data }) {
      try {
        const action = await Projects.save(data);

        if (!action) throw Error;

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return action;
      } catch (error) {
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return error;
      }
    },
    async edit({ commit }, { code, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      try {
        const action = await Projects.update({ code }, data);

        if (!action) throw Error;

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return action;
      } catch (error) {
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return error;
      }
    }
  }
};
